<template>
  <div
    :grc_placeholder="placeholder"
    :grc_labeltext="labeltext"
    :grc_labelmode="labelmode"
    :grc_labelwidth="labelwidth"
    :grc_readonly="readonly"    

    :grc_dateformat="settings.dateformat"
    :grc_sep="settings.datesep"
    :grc_firstdayofweek="settings.firstdayofweek"
    :grc_daynames="settings.daynames"
    :grc_monthnames="settings.monthnames"
    :grc_dropdownwidth="settings.dropdownwidth"
    :grc_dropdownheight="settings.dropdownheight"

    :value="component_value"
  >
    <div ref="comp_container" :class="['grccomp_container', labelmode=='table' ? 'grccomp_container_tablemode' : '']">
      <div ref="container_label" 
        :class="['grccomp_container_label', labelmode=='nolabel' ? 'grccomp_container_nolabel' : '', comp_focused ? 'grccomp_container_label_focused' : '']"
        v-bind:style="{ 'width': labelwidth }"
      >{{labeltext}}</div>
      <div ref="container_input" class="grccomp_container_input">
        <input ref="textinput" type="text" class="grc-input" inputmode="numeric" 
        v-model="display_text" 
        @input="onInput" 
        @blur="onInputBlur" 
        @focus="onInputFocus($event)" 
        @keydown="onInputKeydown"
        :readonly="readonly == 'true'"
        v-bind:placeholder="placeholder" />

        <span 
          :class="['far','fa-calendar-alt', labelmode=='above' ? 'grc-input-dropdown-icon-labelabove' : 'grc-input-dropdown-icon-labelleft']"
          @click="OpenDropdown"
        />
      </div>
    </div>

    <div ref="dropdown_cont_layer" class="grc_dropdown_fullscreen_layer" style="background-color:rgba(100,100,100,0.2);" v-show="dropdown_opened>0" @click="CloseDropdown" @keydown="onLayerKeydown"
      >
      <resize-observer @notify="onLayerResize" />
      <div ref="dropdown_cont" class="grc-input-dropdown-cont" 
        v-bind:style="{ 'left': dropdown_left, 'top': dropdown_top, 'width':settings.dropdownwidth+'px', 'height':settings.dropdownheight+'px' }" 
        @click="DropdownCont_click($event)"
      >
        <div ref="dropdown_proxy" tabindex="-1" class="grc_focus_proxy" @click="FocusProxy" @keydown.esc="CloseDropdown">
          
            <GrcCalendar ref="calendar" v-model="dropdown_value" 
            :grc_dateformat="settings.dateformat" 
            :grc_sep="settings.datesep"
            :grc_firstdayofweek="settings.firstdayofweek"
            :grc_daynames="settings.daynames"
            :grc_monthnames="settings.monthnames"
            @closedropdown="CloseDropdown"
            />


        </div>
      </div>
    </div>

    <GrcCompErrorBubble ref="ErrorBubble" />
  </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import GrcCalendar from '../GrcComponents/GrcCalendar.vue'
import GrcCompErrorBubble from '../GrcComponents/GrcCompErrorBubble.vue'

export default {
  name: 'GrcDate',
  components:
  {
    GrcCalendar,
    GrcCompErrorBubble
  },
  props: {
    value: String,
    grc_placeholder: String,
    grc_labeltext: String,
    grc_labelmode: String,
    grc_labelwidth: String,
    grc_readonly: String,    

    grc_dateformat: String,
    grc_sep: String,
    grc_firstdayofweek: String,
    grc_daynames: String,
    grc_monthnames: String,
    grc_dropdownwidth: String,
    grc_dropdownheight: String
  },
  data () {
    return {
        component_value: "",
        prev_component_value: "",

        display_text: "",
        prev_display_text: "",         

        placeholder: this.grc_placeholder,
        labeltext: this.grc_labeltext,
        labelmode: this.grc_labelmode,
        labelwidth: this.grc_labelwidth,
        readonly: this.grc_readonly,

        comp_focused: false,
        settings: { dateformat: this.grc_dateformat, datesep: this.grc_sep, firstdayofweek: this.grc_firstdayofweek, 
        daynames: this.grc_daynames, monthnames: this.grc_monthnames,
        dropdownwidth: this.grc_dropdownwidth, dropdownheight: this.grc_dropdownheight },

        dropdown_opened: 0,
        dropdown_left: "0px",
        dropdown_top: "0px",
        dropdown_value:"",

        lastlayerwidth:0,
    }
  },
  watch : {
    value (pNewValue) {
      if (pNewValue !== this.prev_component_value) {
          this.prev_component_value = pNewValue;
          this.component_value = pNewValue;
          this.DisplayValue(pNewValue);
      }
    },

    display_text()
    {
        if (this.comp_focused == false) { return; }
        if (this.display_text != this.prev_display_text)
        {
            if (this.CheckText(this.display_text) == false)
            {
                this.display_text = this.prev_display_text;
            }
            else
            {
                this.prev_display_text = this.display_text;
            }
        }
    },

    dropdown_value()
    {
      this.display_text = this.dropdown_value;
    }
  },

  created: function()
  {
    if (typeof this.labelmode == "undefined")
    {
      this.labelmode = "nolabel";
    }

    var labelmodes = ["table", "above", "nolabel"];
    if (labelmodes.includes(this.labelmode) == false)
    {
      this.labelmode = "above";
    }

    if (typeof this.labelwidth == "undefined")
    {
      this.labelwidth = "";
    }


    this.ValidateFormat();
    this.ValidateSeparator();
    this.ValidateFirstDayOfWeek();
    this.ValidateDayNames();
    this.ValidateMonthNames();
    this.ValidateDropdownSize();


    if (typeof this.placeholder == "undefined")
    {
      var s = "";
      if (this.settings.dateformat == "ymd") { s = "    .  .  "; }
      if (this.settings.dateformat == "mdy") { s = "  .  .    "; }
      if (this.settings.dateformat == "dmy") { s = "  .  .    "; }
      this.placeholder = s.replace(/[.]/g,this.settings.datesep);
    }


    if (typeof this.value != "undefined")
    {
      this.prev_component_value = this.value;
      this.component_value = this.value;
      this.DisplayValue(this.component_value);
    }

  },
  computed: {
    
  },
  methods: {

    SetLabel(pText)
    {
      this.labeltext = pText;
    },

    ShowError(pText)
    {
      this.$refs.ErrorBubble.ShowError(pText);
    },

    HideError()
    {
      this.$refs.ErrorBubble.HideError();
    },


    onLayerResize()
    {
      var layerpos = grccomp_findPos(this.$refs.dropdown_cont_layer);
      //console.log("opened: "+this.dropdown_opened+"  last: "+this.lastlayerwidth+"  currw: "+layerpos.width);
      if (this.dropdown_opened != 2) { return; }
      
      if (this.lastlayerwidth != layerpos.width)
      {
        this.CloseDropdown();
      }
    },

    ValidateDropdownSize()
    {
      if (typeof this.settings.dropdownwidth == "undefined")
      {
        this.settings.dropdownwidth = grccomp_GetDefaults_Date().dropdownwidth;
      }

      if (typeof this.settings.dropdownheight == "undefined")
      {
        this.settings.dropdownheight = grccomp_GetDefaults_Date().dropdownheight;
      }

    },

    ValidateFormat()
    {
      var formatlist = ["ymd", "mdy", "dmy"];
      if (formatlist.includes(this.settings.dateformat) == false)
      {
        this.settings.dateformat = grccomp_GetDefaults_Date().dateformat;
      }
    },

    ValidateSeparator()
    {
      var seplist = [".", "-", "/"];
      if (seplist.includes(this.settings.datesep) == false)
      {
        this.settings.datesep = grccomp_GetDefaults_Date().sep;
      }
    },

    ValidateDayNames()
    {
      if (typeof this.settings.daynames == "undefined")
      {
        this.settings.daynames = grccomp_GetDefaults_Date().daynames;
      }

      var sa = this.settings.daynames.split(",");
      if (sa.length<7)
      {
        this.settings.daynames = grccomp_GetDefaults_Date().daynames;
        sa = this.settings.daynames.split(",");
      }

      var tharr = new Array();
      if (this.settings.firstdayofweek == "mon")
      {
        for(var i=1; i<sa.length;i++)
        {
          var o = new Object();
          o.text = ""+sa[i];
          tharr.push(o);
        }
        var o = new Object();
        o.text = ""+sa[0];
        tharr.push(o);
      }
      else
      {
        for(var i=0; i<sa.length;i++)
        {
          var o = new Object();
          o.text = ""+sa[i];
          tharr.push(o);
        }
      }

      this.th_daynames = Array.from(Object.create(tharr));

    },

    ValidateMonthNames()
    {
      if (typeof this.settings.monthnames == "undefined")
      {
        this.settings.monthnames = grccomp_GetDefaults_Date().monthnames;
      }

      var sa = this.settings.monthnames.split(",");
      if (sa.length<12)
      {
        this.settings.monthnames = grccomp_GetDefaults_Date().monthnames;
      }
    },


    ValidateFirstDayOfWeek()
    {
      var formatlist = ["mon", "sun"];
      if (formatlist.includes(this.settings.firstdayofweek) == false)
      {
        this.settings.firstdayofweek = grccomp_GetDefaults_Date().firstdayofweek;
      }
    },


    DisplayValue(pNewValule)
    {
        var s = this.FormatText(pNewValule);

        this.prev_display_text = s;
        this.display_text = s;
    },

    CheckText: function(pText)
    {
      var CheckOK = true;
      
      var repchars = "[^0-9"+this.settings.datesep+"]+";
      var regex = new RegExp(repchars, "g");
      var cv = pText.replace(regex, "");

      if (cv != pText) { CheckOK = false; }
      
      var onlyNum = pText.replace(/[^0-9]+/g, '');

      if (cv.length - onlyNum.length >2) { CheckOK = false; } // kettonel tobb separator
      if (onlyNum.length > 8) { CheckOK = false; } // 8 szamjegynel tobb

      return CheckOK;
    },

    FormatText: function(pText)
    {
      if (pText == null) { pText = ""; }

      var onlyNum = pText.replace(/[^0-9]+/g, '');

      var res = "";

      if (onlyNum == "") { res = ""; }
      else
      {
        onlyNum = onlyNum.padEnd(8, ' ');

        if (this.settings.dateformat == "ymd")
        {
          res = onlyNum.substr(0, 4)+this.settings.datesep+onlyNum.substr(4, 2)+this.settings.datesep+onlyNum.substr(6, 2);
        }
        else
        {
          res = onlyNum.substr(0, 2)+this.settings.datesep+onlyNum.substr(2, 2)+this.settings.datesep+onlyNum.substr(4, 4);
        }

        res = res.replace(/ /g, '');
      }

      return res;
    },

    onInputBlur()
    {
      if (this.IsReadonly()) 
      {
        this.$emit('grc-blur');
        return;
      }

      var s = this.FormatText(this.display_text);
      
      //this.display_text = s;
      //this.prev_display_text = s;
      
      var ValueChanged = (s != this.prev_component_value);

      this.component_value = s;

      this.comp_focused = false;

      if (ValueChanged)
      {
        this.$emit('input', this.component_value);
      }
      else
      {
        this.prev_component_value = this.component_value;
        this.DisplayValue(this.component_value);          
      }

      this.$emit('grc-blur');

    },

    onInput (e) {
      //if (e.isTrusted) { return; } // ignore native event
    },

    onLayerKeydown(e)
    {
      if (e.keyCode == 27)
      {
        this.CloseDropdown();
        e.stopPropagation();
        e.preventDefault();
      }
    },



    onInputKeydown(e)
    {
      if ((e.keyCode == 13) || (e.keyCode == 9)) {}
      else
      {
        this.$refs.ErrorBubble.HideError();
      }

      this.$emit('grc-keydown', e.keyCode);
      if (e.keyCode == 13)
      {
        this.$emit('grc-keydown-enter');
        return;
      }

      if (e.keyCode == 34)
      {
        this.OpenDropdown();
      }
    },

    onInputFocus(e)
    {
      this.comp_focused = true;
      this.DisplayValue(this.component_value);
        Vue.nextTick(function () {
            //e.target.select();
        });      
      this.$emit('grc-focus');
    },

    SetFocus()
    {
      this.$refs.textinput.focus();
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    },

    OpenDropdown()
    {
      if (this.dropdown_opened > 0) { this.dropdown_opened = 0; return; }
      if (this.readonly == "true") { return; }

      grcmain_SetBodyScrollable(false);      

      var bodysize = grccomp_getBodySize();

      var elpos = grccomp_findPos(this.$refs.textinput);

      var ch = parseInt(this.settings.dropdownheight);
      var cw = parseInt(this.settings.dropdownwidth);


      elpos.top = elpos.top - bodysize.scrollTop;
      var screensize = grccomp_getScreenSize();

      if (elpos.top + elpos.height + ch <= screensize.height)
      {
        elpos.top = elpos.top + elpos.height;
      }
      else
      {
        elpos.top = elpos.top - ch - 8;
      }

      if (elpos.top < 0) { elpos.top = 0; }



      // jobbra igazitas
      elpos.left = elpos.left + elpos.width - cw;
      if (elpos.left < 5) { elpos.left = 5; }
      // end: jobbra igazitas




      this.lastlayerwidth = 0;


      this.dropdown_left = ""+elpos.left+"px";
      this.dropdown_top = ""+elpos.top+"px";

      this.dropdown_value = this.display_text;
      this.dropdown_opened = 1;

      this.$emit("dropdownopened");
    },

    CloseDropdown()
    {
      grcmain_SetBodyScrollable(true);
      this.$emit("dropdownclosed");
      //console.log("cal blur");
      this.dropdown_opened = 0;
      this.$refs.textinput.focus();

    },

    DropdownCont_click(e)
    {
      //console.log("click");
      e.preventDefault();
      e.stopPropagation();
    },

    FocusProxy()
    {
      this.$refs.dropdown_proxy.focus();
    },

    SetText(pText)
    {
      this.prev_component_value = pText;
      this.component_value = pText;
      this.DisplayValue(pText);
      this.$emit('input', this.component_value);
    },

    GetText()
    {
      return this.component_value;
    },

    IsValid(pCanBeEmpty)
    {
      if ((pCanBeEmpty)&&(this.component_value.length == 0)) { return true; }
      if (this.component_value.length != 10) { return false; }

      return (moment(this.component_value,"YYYY.MM.DD").isValid());
    },





    
  },

  updated: function()
  {
    //console.log("updated: "+this.dropdown_opened);
    this.$nextTick(function () {
      if (this.dropdown_opened == 1)
      {
        var layerpos = grccomp_findPos(this.$refs.dropdown_cont_layer);
        this.lastlayerwidth = layerpos.width;

        this.dropdown_opened = 2;
        this.$refs.dropdown_proxy.focus();
      }
    });
  }
}
</script>

